<template>
    <div>

    </div>
</template>

<script>
    export default {
        methods: {
            makeToast(variant = null, title = '', body= '') {
                this.$bvToast.toast(body, {
                    title: title,
                    variant: variant,
                    solid: true
                })
            }
        }
    }
</script>